const GATEWAY = import.meta.env.VITE_GATEWAY_URL ?? "http://localhost:8080";
const TOKEN_KEY = "spider_token";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export class ApiError extends Error {
  constructor(public status: number, public code: string, message?: string) {
    super(message ?? code);
  }
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {}
): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  const token = getToken();
  if (token) headers.set("authorization", `Bearer ${token}`);

  const res = await fetch(`${GATEWAY}${path}`, { ...init, headers });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    const code = body.error ?? `http_${res.status}`;
    // Only a GENUINE auth failure should drop the session. Some endpoints return
    // 401 for non-login reasons (e.g. a wrong device password on
    // /connect/by-code) — those must surface as themselves and keep the user
    // signed in. We treat 401 as session-expiry only when the body says so (or
    // is empty). Routes detect the missing token and render <Login/>.
    if (res.status === 401 && (code === "unauthorized" || code === "http_401")) {
      clearToken();
      throw new ApiError(401, "unauthorized");
    }
    throw new ApiError(res.status, code);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
